import { EventEmitter, Injectable, Output } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CreateBlogModalComponent } from "src/app/shared/modals/create-blog-modal/create-blog-modal.component";
import { BlogsBaseModel } from "../../models/blogs/blogs-base.model";

@Injectable({
  providedIn: 'root'
})
export class BlogModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: BlogsBaseModel, editMode?: boolean) {
    var modalRef!: NgbModalRef;
    modalRef = this.modalService.open( CreateBlogModalComponent, {windowClass : "myCustomModalClassUnderTopBar", size: 'xxl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
    if(model){
        modalRef.componentInstance.model = model;
        modalRef.componentInstance.editMode = editMode;
    }
    modalRef.result.then(() => {
        this.modelChanged.emit(true);
        modalRef.componentInstance.ngOnDestroy();
      });
  }
}